import * as React from "react"
import {Box, Typography} from "@mui/material";

import {currentPeriod} from "@signals"
import { dateRangeTranslator } from "@utils";


export default function CommonFiltersDateRangeSelected() {
    return <Typography variant="caption" sx={{ backgroundColor: "#eef1f3", py: .5, px: 1, textWrap: 'nowrap' }}>
        {dateRangeTranslator(currentPeriod.value)}
    </Typography>
}